module.exports = __webpack_public_path__ + "assets/img/clal2.6b1d20fc.jpg";